// src/sections/OrderPhone/OrderPhone.js
import React from 'react';
import styles from './OrderPhone.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'; // faWhatsapp n'est plus nécessaire

const OrderPhone = ({ id }) => {
  const phoneNumber = "06 98 01 25 29";
  // const whatsappNumber = "33698012529"; // Numéro WhatsApp supprimé

  return (
    <section id={id} className={styles.orderPhone}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>COMMANDER PAR TÉLÉPHONE</h2>
        <p className={styles.introText}>
          Passez votre commande facilement par téléphone pour un retrait rapide.
          N'hésitez pas à nous appeler durant nos heures d'ouverture.
        </p>

        <div className={styles.contactDetails}>
          {/* SEUL LE LIEN TÉLÉPHONE EST CONSERVÉ ET MIS EN VALEUR */}
          <p className={styles.phoneLink}>
            <a href={`tel:${phoneNumber}`}>
              <FontAwesomeIcon icon={faPhoneAlt} className={styles.icon} /> {phoneNumber}
            </a>
          </p>
          {/* L'option WhatsApp est supprimée */}
        </div>

        <div className={styles.instructions}>
          <h3 className={styles.subTitle}>Comment commander ?</h3>
          <ol>
            <li>Préparez votre liste de plats favoris ou consultez notre menu complet.</li>
            <li>Appelez-nous au numéro ci-dessus.</li>
            <li>Donnez-nous votre commande et l'heure de retrait souhaitée.</li>
            <li>Venez récupérer votre repas chaud et savoureux !</li>
          </ol>
        </div>

        <p className={styles.note}>
          Pour les commandes spéciales ou de grande quantité, veuillez nous prévenir à l'avance.
        </p>
      </div>
    </section>
  );
};

export default OrderPhone;